import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop Component
 * Listens for route changes via standard React Router hooks and forces
 * an instantaneous vertical scroll reset to position 0, 0.
 * Fired inside useLayoutEffect to prevent layout jumpiness or cumulative layout shift.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // Reset window position immediately on route transition
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
